// localStorage sin sorpresas: en modo privado o con el almacenamiento lleno puede fallar, y la tienda tiene que seguir
// andando igual (sin recordar nada).

export function leer<T>(clave: string): T | null {
  try {
    const v = localStorage.getItem(clave);
    return v === null ? null : (JSON.parse(v) as T);
  } catch {
    return null;
  }
}

export function guardar(clave: string, valor: unknown): void {
  try {
    localStorage.setItem(clave, JSON.stringify(valor));
  } catch {
    /* sin lugar o bloqueado: queda solo en memoria */
  }
}

export function borrar(clave: string): void {
  try {
    localStorage.removeItem(clave);
  } catch {
    /* nada que hacer */
  }
}

/** Avisa cuando otra pestaña cambia una clave (la sesión o el carrito abiertos en dos pestañas). */
export function alCambiarEnOtraPestana(clave: string, f: (valor: unknown) => void): () => void {
  const oyente = (e: StorageEvent) => {
    if (e.key !== clave) return;
    try {
      f(e.newValue === null ? null : JSON.parse(e.newValue));
    } catch {
      f(null);
    }
  };
  window.addEventListener('storage', oyente);
  return () => window.removeEventListener('storage', oyente);
}
